var chunkMapping = {
	"36": [
		8063
	],
	"229": [
		3329,
		662,
		9170,
		8910,
		290,
		9795,
		8331
	],
	"521": [
		9521
	],
	"595": [
		8595
	],
	"886": [
		886
	]
};
var idToExternalAndNameMapping = {
	"290": [
		"default",
		"./stores",
		3162
	],
	"662": [
		"default",
		"./useHubCardMemberships",
		6134
	],
	"886": [
		"default",
		"./HeaderHomeNotification",
		4648
	],
	"3329": [
		"default",
		"./useHubRoutes",
		619
	],
	"8063": [
		"default",
		"./TelevetProductSection",
		1589
	],
	"8331": [
		"default",
		"./useCurrentAccountContracts",
		6134
	],
	"8595": [
		"default",
		"./VPISection",
		2819
	],
	"8910": [
		"default",
		"./useMostViewedTelevetRoutes",
		1589
	],
	"9170": [
		"default",
		"./useHubRoutes",
		6134
	],
	"9521": [
		"default",
		"./PrivacyAndTermsCheck",
		8521
	],
	"9795": [
		"default",
		"./components/sections",
		3162
	]
};
var idToRemoteMap = {
	"290": [
		{
			"externalType": "script",
			"name": "medical",
			"externalModuleId": 3162
		}
	],
	"662": [
		{
			"externalType": "script",
			"name": "contract",
			"externalModuleId": 6134
		}
	],
	"886": [
		{
			"externalType": "script",
			"name": "notification",
			"externalModuleId": 4648
		}
	],
	"3329": [
		{
			"externalType": "script",
			"name": "clubePublication",
			"externalModuleId": 619
		}
	],
	"8063": [
		{
			"externalType": "script",
			"name": "televet",
			"externalModuleId": 1589
		}
	],
	"8331": [
		{
			"externalType": "script",
			"name": "contract",
			"externalModuleId": 6134
		}
	],
	"8595": [
		{
			"externalType": "script",
			"name": "contractLegacy",
			"externalModuleId": 2819
		}
	],
	"8910": [
		{
			"externalType": "script",
			"name": "televet",
			"externalModuleId": 1589
		}
	],
	"9170": [
		{
			"externalType": "script",
			"name": "contract",
			"externalModuleId": 6134
		}
	],
	"9521": [
		{
			"externalType": "script",
			"name": "term",
			"externalModuleId": 8521
		}
	],
	"9795": [
		{
			"externalType": "script",
			"name": "medical",
			"externalModuleId": 3162
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}